import React from 'react';
import { string, object } from 'prop-types';

import Layout from '../../components/Layout';
import Title from '../../components/Title';

const Template2Cols = ({ pageTitle, data, children }) => (
  <Layout pageTitle={pageTitle} data={data}>
    <Title title={pageTitle} />
    <section className="slice bg-3">
      <div className="w-section inverse">
        <div className="container">
          <div className="row">{children}</div>
        </div>
      </div>
    </section>
  </Layout>
);

Template2Cols.propTypes = { pageTitle: string, data: object, children: object };

Template2Cols.defaultProps = { pageTitle: string, data: {}, children: null };

export default Template2Cols;
